import { DEFAULT_SERVICE_ICON_URL_GREY } from '@zapier/product-get-help/esm/constants';
const DEFAULT_APP_ID = 'PlaceholderAPI';
export const getSelectedZap = ({ data, isLoading = false, onSelect, selectedZap, }) => {
    if (!selectedZap) {
        return null;
    }
    // The case when pre-filled
    if (typeof selectedZap === 'string') {
        const nodeId = selectedZap;
        if (!isLoading) {
            for (const gi in data) {
                for (const fi in data[gi].folders) {
                    for (const zi in data[gi].folders[fi].zaps) {
                        const zap = data[gi].folders[fi].zaps[zi];
                        if (zap.id === nodeId) {
                            // Replace the pre-filled ID by the object
                            onSelect(zap);
                            return zap;
                        }
                    }
                }
            }
        }
        return {
            id: nodeId,
            title: `#${selectedZap} (${isLoading
                ? 'loading icons and title...'
                : 'could not load icon and title'})`,
            nodes: [
                {
                    id: nodeId,
                    selectedApi: DEFAULT_APP_ID,
                    appImage64: DEFAULT_SERVICE_ICON_URL_GREY,
                },
            ],
        };
    }
    return selectedZap;
};
